import React, { useContext, useState } from 'react'
import { FloatButton, message } from 'antd';

//styles
import "./Layout.css"

//components
import Navbar from './navbar/Navbar';
import Sidebar from './sidebar/Sidebar';
import { FaWhatsapp } from 'react-icons/fa6';
import { PromiseSesionContext } from '../machines/ErrorMachine';
import NavbarAdmin from './NavbarAdmin/NavbarAdmin';

interface Props {
    children: React.ReactNode
}

const Layout = ({children}:Props) => {
  const { sesion } = useContext(PromiseSesionContext); // Consumimos la sesión
  const [messageApi, contextHolder] = message.useMessage();

  // Extraemos el rol para facilitar la lectura
  const isAdmin = sesion.context.rol === 'admin';
  
  const [open, setOpen] = useState<boolean>(false);

  const redirect = () => {
    const numeroTelefono = '584221741571'; // Reemplaza con el número de teléfono
    let mensaje = '¡Hola! ¿Cómo puedo concretar la compra?';

    const urlWhatsApp = `https://wa.me/${numeroTelefono}?text=${encodeURIComponent(mensaje)}`;
    window.open(urlWhatsApp, '_blank'); 

  }

  return (
    <div className={isAdmin ? "Layout-component-admin" :'Layout-component'}>

        {isAdmin ?<NavbarAdmin /> : <Navbar setOpen={setOpen}/>}

        <Sidebar open={open} setOpen={setOpen} />
        <div className={isAdmin ? "Layout-children-admin":'Layout-children'}>
          {children}
        </div>

        {/* <FloatButton icon={<FaWhatsapp size={20} />}  onClick={() => redirect()} />; */}
    </div>
  )
}

export default Layout